import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GetClient } from '@/services/Clients/GetClient';
import { ClientInterface } from '../types/clientInterface';

export const useClientStore = defineStore('client', () => {
  const client = ref<ClientInterface>({
    id: null,
    clientImageUrl: '',
    defaultClientImageUrl: '',
    parentBaseUrl: '',
    changePasswordUrl: '',
  });

  const getClient = async () => {
    const response: ClientInterface = await GetClient();

    client.value = response;
  };

  const getClientResponse = async () => {
    const response = await GetClient();

    return response;
  };

  return {
    client,
    getClient,
    getClientResponse,
  };
});
